export default __webpack_public_path__ + "static/media/monitor-mobbile.dfb06c30.svg";